import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {catchError, map} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {ApiConstants} from '@coreConstant';
import {PaginationModel, ProjectCategoryModel, RequestParamModel} from '@coreModels';
import { ToastService } from '../toast.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureProjectService {
  constructor(
    private http: HttpClient,
    private baseService: BaseService,
    private toastService: ToastService
  ) {
  }

  /**
   * Fetch the list of feature projects.
   * @param requestParamModel - Request parameters for filtering and sorting projects.
   * @returns An observable containing an array of feature projects.
   */
  getFeaturesProjects(requestParamModel: any): any {
    return this.http.get(ApiConstants.FEATURE_PROJECT_LIST_URL + requestParamModel.getParams())
      .pipe(
        map<any, any>(response => {
          return response.data as any[];
        }),
        catchError((error: any) => {
          this.toastService.showError(error)
          return throwError(() => new Error('Failed to fetch project data'));
        })
      );
  }

  /**
   * Fetch the list of project categories.
   * @param requestParamsModel - Optional request parameters for filtering and sorting categories.
   * @returns A pagination model containing project categories and header information.
   */
  getProjectsCategory(requestParamsModel?: RequestParamModel): Observable<PaginationModel<ProjectCategoryModel>> {
    return this.baseService
      .get(ApiConstants.PROJECT_CATEGORY_LIST_URL, requestParamsModel || new RequestParamModel())
      .pipe(
        map((response: any) => {
          const categoryList = new PaginationModel<ProjectCategoryModel>();
          const headers = response.headers;
          categoryList.setHeaders(headers);
          categoryList.data = response.body.data as ProjectCategoryModel[];
          return categoryList;
        }),
        catchError((error: any) => {
          this.toastService.showError(error)
          return throwError(() => new Error(error));
        })
      );
  }

  /**
   * Fetch a specific project by its ID.
   * @param id - The ID of the project to retrieve.
   * @param requestParamModel - Optional request parameters.
   * @returns An observable containing the project details.
   */
  getProjectById(id: number, requestParamModel?: RequestParamModel): Observable<any> {
    return this.baseService
      .get(`${ApiConstants.FEATURE_PROJECT_DETAIL_URL}/${id}`, requestParamModel)
      .pipe(
        map((response: any) => response.body.data),
        catchError((err) => {
          this.toastService.showError(err)
          return throwError(() => new Error(err));
        })
      );
  }
}
